import { type FC, useState } from 'react';
import { DefaultValues, SubmitHandler } from 'react-hook-form';
import { VStack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import { UserBankDetailsForm } from 'components/UserBankDetailsForm';
import { UserBankDetailsFormSchema } from 'components/UserBankDetailsForm/schema';
import * as Layout from 'layouts/StickyStepperLayout';

import locales from './locales';

const FORM_NAME = 'EditBankDetailsForm';

interface BankDetailsFormProps {
  onSubmit: SubmitHandler<UserBankDetailsFormSchema>;
  defaultValues?: DefaultValues<UserBankDetailsFormSchema>;
  isSaving?: boolean;
}

export const EditBankDetailsForm: FC<BankDetailsFormProps> = ({
  defaultValues,
  isSaving,
  onSubmit,
}) => {
  const [isValid, setIsValid] = useState(false);

  return (
    <>
      <Layout.ContentsContainer gap="space-40">
        <VStack align="flex-start" spacing="space-16">
          <Heading size="lg">{locales.title}</Heading>
          <Text size="lg">{locales.description}</Text>
        </VStack>
        <UserBankDetailsForm
          defaultValues={defaultValues}
          disabled={isSaving}
          id={FORM_NAME}
          onSubmit={(formData) => onSubmit(formData)}
          onValidStateChanged={setIsValid}
        />
      </Layout.ContentsContainer>
      <Layout.FooterContainer>
        <Layout.FooterButtonsContainer>
          <Button
            form={FORM_NAME}
            isDisabled={!isValid}
            isLoading={isSaving}
            type="submit"
          >
            {locales.submit}
          </Button>
        </Layout.FooterButtonsContainer>
      </Layout.FooterContainer>
    </>
  );
};
